import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { Button } from '@orijinworks/frontend-commons';
import { MAX_BULK_SELECTION } from '../constants/program-certificates.constants';

const BulkActionBar = ({
  selectedCount,
  loading,
  onGenerate,
  onClearSelection,
}) => {
  if (selectedCount === 0) {
    return null;
  }

  const atLimit = selectedCount >= MAX_BULK_SELECTION;

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      gap={1}
      py={1.5}
      data-testid="program-certificates-bulk-bar"
    >
      <Typography variant="body2">
        {selectedCount} selected
        {atLimit ? ` (max ${MAX_BULK_SELECTION})` : ''}
      </Typography>
      <Button
        color="primary"
        variant="contained"
        size="small"
        disabled={loading}
        onClick={onGenerate}
        data-testid="bulk-generate-btn"
      >
        Generate Certificates
      </Button>
      <Button
        color="default"
        variant="outlined"
        size="small"
        disabled={loading}
        onClick={onClearSelection}
        data-testid="clear-selection-btn"
      >
        Clear selection
      </Button>
    </Box>
  );
};

BulkActionBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  onGenerate: PropTypes.func.isRequired,
  onClearSelection: PropTypes.func.isRequired,
};

BulkActionBar.defaultProps = {
  loading: false,
};

export default BulkActionBar;
